// SellerPage.tsx
import { useEffect, useState } from 'react'
import { useLanguage } from '../../context/LanguageContext'
import api from '../../lib/api.ts'
import { SellerHero } from './seller-hero'
import { SellerHowItWorks } from './seller-how-it-works'
import { WhySellSection } from './why-sell-section'
import { FaqSection } from '../newbuyerpage/faq-section' // unchanged path
import { SellerCtaSection } from './seller-cta-section'
import { getPageSettings } from "../../services/pagesettingServices.ts" // for FAQs
import SellerPlansSection from './seller-plans-section.jsx'
import usePageMeta from "../../hooks/usePageMeta.js";


export default function SellerPage() {
   usePageMeta("seller");
  const { language } = useLanguage()

  // Main seller page data (clientsellerpage)
  const [pageData, setPageData] = useState(null)
  const [loadingMain, setLoadingMain] = useState(true)
  const [errorMain, setErrorMain] = useState(null)

  // Separate FAQ data (sellerfaqs) - old implementation
  const [faqs, setFaqs] = useState([])
  const [loadingFaqs, setLoadingFaqs] = useState(true)
  const [errorFaqs, setErrorFaqs] = useState(null)

  // Fetch main seller page content
  useEffect(() => {
    const fetchSellerPage = async () => {
      try {
        setLoadingMain(true)
        setErrorMain(null)

        const response = await api.get('/pagesettings/clientsellerpage', {
          params: { lang: language },
        })

        setPageData(response.data || {})
      } catch (err) {
        console.error('❌ Error fetching seller page:', err)
        setErrorMain('Failed to load seller page content')
      } finally {
        setLoadingMain(false)
      }
    }

    fetchSellerPage()
  }, [language])

  // Fetch FAQs separately (unchanged old implementation)
  useEffect(() => {
    const fetchSellerFaqs = async () => {
      try {
        setLoadingFaqs(true)
        setErrorFaqs(null)

        const response = await getPageSettings({
          page: "sellerfaqs",
          lang: language,
        })

        const seller_faqs = response?.seller_faqs || response?.data?.seller_faqs || []
        setFaqs(seller_faqs)
      } catch (err) {
        console.error("❌ Error fetching seller FAQs:", err)
        setErrorFaqs(err)
        setFaqs([])
      } finally {
        setLoadingFaqs(false)
      }
    }

    fetchSellerFaqs()
  }, [language])

  // Extract sections safely
  const heroBanner       = pageData?.hero_banner?.[0]       || {}
  const sellerStepHeader = pageData?.seller_step_header?.[0] || {}
  const sellerSteps      = pageData?.seller_steps           || []
  const whySellHeader    = pageData?.why_sell_header?.[0]   || {}
  const whySellBenefits  = pageData?.why_sell_benefits      || []
  const sellerCta        = pageData?.seller_cta_section?.[0] || {}

  const isLoading = loadingMain || loadingFaqs

  if (isLoading) {
    return (
      <main className="bg-bg-dark text-foreground min-h-screen flex items-center justify-center">
        <div className="text-white text-xl">Loading seller page...</div>
      </main>
    )
  }

  if (errorMain) {
    return (
      <main className="bg-bg-dark text-foreground min-h-screen flex items-center justify-center">
        <div className="text-red-500 text-xl">{errorMain}</div>
      </main>
    )
  }

  return (
    <main className="bg-bg-dark text-foreground">
      <SellerHero heroBanner={heroBanner} />

      <SellerHowItWorks 
        header={sellerStepHeader}
        steps={sellerSteps}
      />

      <WhySellSection 
        header={whySellHeader}
        benefits={whySellBenefits}
        btntext={heroBanner?.btnText?.value}
        btnlink={heroBanner?.btnLink?.value}
      />
      <SellerPlansSection/>

      {/* FAQ remains exactly as old implementation */}
      <FaqSection
        faqs={faqs}
        loading={loadingFaqs}
        error={errorFaqs}
      />

      <SellerCtaSection ctaData={sellerCta} />
    </main>
  )
}